import React, {useRef} from "react";
import { DataTable, Tag, Icon, ButtonIcon } from 'pepsico-ds'
import InfoIcon from '../Icons/InfoIcon';
// import * as XLSX from 'xlsx';
import { exportRowsToExcel } from '../../utils/excelExport';
import { saveAs } from 'file-saver';
import download_logo from '../../assets/download_logo.png'
import DropdownWithIcons from "../Modal/DropdownWithIcons";
import { useToast } from '../../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'
function SmartCubeTable({ currentData, year, appList }) {
  
  const currentYear = year;
  const data = currentData;
  const years = Array.from({ length: 4 }, (_, i) => currentYear + i);
  const yearColumnObjects = years.map((year, index) => ({
    columnKey: `marketSize_${index}`,
    header: `Market Size ${year}`,
    cellData: (ctx) => {
      const marketSize = ctx.row.original[`marketSize_${index}`];
      return marketSize == null ? "-" : <span>{marketSize}</span>
    },
    initialSize: 90,
    minSize: 50,
    maxSize: 140
  }));

  const columns = [
    { columnKey: 'smartCubeSector', header: 'Smartcube sector' },
    { columnKey: 'l0Category', header: 'PEPSICO L0 CATEGORY', initialSize: 90, minSize: 50, maxSize: 140 },
    { columnKey: 'l1Category', header: 'PEPSICO L1 CATEGORY', initialSize: 90, minSize: 50, maxSize: 140 },
    // { columnKey: 'l2Category', header: 'PEPSICO L2 CATEGORY', size: 90, minSize: 50, maxSize: 140 },
    {
      columnKey: 'smartCubeCategoryWithLink',
      header: 'Mapped SmartCube Categories',
      // OLD HEADER header: ()=>
      //               <span style={{fontStyle:"italic",textTransform:"lowercase", fontWeight:500}}><a className="blinking-text" href={"https://amplifipro.thesmartcube.com/pepsico/login"} target="_blank"
      //               // onClick={window.open("https://google.com", "_blank")} 
      //               style={{ textDecoration: "None", fontWeight:900, backgroundColor:"#005cbc" ,fontStyle:"normal", 
      //               color:"white",
      //               textTransform:"uppercase"}}>&nbsp;Click here&nbsp;</a><br /> to activate <span style={{textTransform:"uppercase"}}>sc</span> Reports below</span>
      // ,
      cellData: (ctx) => {
        const smartCubeCategoryWithLink = ctx.row.original.smartCubeCategoryWithLink;
        const smartCubeSector = ctx.row.original.smartCubeSector
        const nameAndLink = smartCubeCategoryWithLink?.split("$$");
        return <a href={nameAndLink[1]} target="_blank" style={{ display: "flex", textDecoration: "none", color: "#005CBC" }}><span style={{ textDecoration: "none" }}>{smartCubeSector} - {nameAndLink[0]}</span><Icon alt="" icon="open_in_new" size="small" /></a>
      },
      initialSize: 90, minSize: 50, maxSize: 140
    },
    // {
    //   columnKey: 'Sugar_in_g',
    //   header: 'Sugar (g)',
    //   cellData: (ctx) => {
    //     const { Sugar_in_g } = ctx.row.original
    //     if (Sugar_in_g < 15)
    //       return (
    //         <>
    //           <Tag
    //             text={`Sodium is ${ctx.row.original.Sugar_in_g}`}
    //             isCopyable={false}
    //             color="Green-600"
    //           />
    //         </>
    //       )
    //     return <span>{`Sugar is ${Sugar_in_g}`}</span>
    //   },
    //   size: 90,
    //   minSize: 50,
    //   maxSize: 140,
    // },
  ];
  columns.push(yearColumnObjects[0]);
  columns.push(yearColumnObjects[1]);
  columns.push(yearColumnObjects[2]);
  columns.push(yearColumnObjects[3]);
  columns.push({ columnKey: 'uom', header: 'Unit of Measure', size: 90, minSize: 50, maxSize: 140 })
  columns.push({
    columnKey: 'cagr', header: 'Market Size CAGR',
    cellData: (ctx) => {
      const cagr = ctx.row.original.cagr;
      return cagr == null ? "-" : <span>{`${cagr}%`}</span>
    }, initialSize: 90, minSize: 50, maxSize: 140
  })
  // columns.push({ columnKey: 'categoryRisk', header: 'Category Risk', size: 90, minSize: 50, maxSize: 140 })
  columns.push({ columnKey: 'categoryRisk', header:  () => <span style={{ display: "flex" }}>Category Risk
                                                            <InfoIcon text="On a scale of 1 to 5, with 5 being the riskiest" direction="left" />
                                                            </span>,
   initialSize: 90, minSize: 50, maxSize: 140 })

  // const filters = [
  //   {
  //     disabled: false,
  //     label: 'Filter',
  //     listLabel: 'Header',
  //     onChange: (value) =>
  //       console.log('Selected Values:', value),
  //     options: [
  //       { id: '1', label: 'Option 1' },
  //       { id: '2', label: 'Option 2' },
  //       { id: '3', label: 'Option 3' },
  //     ],
  //   },
  //   {
  //     disabled: false,
  //     label: 'Filter',
  //     listLabel: 'Header',
  //     onChange: (value) =>
  //       console.log('Selected Values:', value),
  //     options: [
  //       { id: '1', label: 'Option 1' },
  //       { id: '2', label: 'Option 2' },
  //       { id: '3', label: 'Option 3' },
  //     ],
  //   },
  //   {
  //     disabled: false,
  //     label: 'Filter',
  //     listLabel: 'Header',
  //     onChange: (value) =>
  //       console.log('Selected Values:', value),
  //     options: [
  //       { id: '1', label: 'Option 1' },
  //       { id: '2', label: 'Option 2' },
  //       { id: '3', label: 'Option 3' },
  //     ],
  //   },
  // ]
//   const downloadExcel = () => {
//     // Define the columns to keep and the desired order
//     const columnsToInclude = [
//       "SMARTCUBE SECTOR",
//       "PEPSICO L0 CATEGORY",
//       "PEPSICO L1 CATEGORY",
//       "MAPPED SMARTCUBE CATEGORIES",
//       "MARKET SIZE 2025",
//       "MARKET SIZE 2026",
//       "MARKET SIZE 2027",
//       "MARKET SIZE 2028",
//       "UOM",
//       "MARKET SIZE CAGR",
//       "CATEGORY RISK"
//     ];     // Use uppercase for final header names
//     const columnMapping = {
//       "smartCubeSector": "SMARTCUBE SECTOR",
//       "l0Category": "PEPSICO L0 CATEGORY",
//       "l1Category": "PEPSICO L1 CATEGORY",
//       "smartCubeCategoryWithLink": "MAPPED SMARTCUBE CATEGORIES",
//       "marketSize_0": "MARKET SIZE 2025",
//       "marketSize_1": "MARKET SIZE 2026",
//       "marketSize_2": "MARKET SIZE 2027",
//       "marketSize_3": "MARKET SIZE 2028",
//       "uom": "UOM",
//       "cagr": "MARKET SIZE CAGR",
//       "categoryRisk": "CATEGORY RISK"
//     };             

//     // Transform the data
//     const transformedData = data.map(item => {
//         const newItem = {};
//         columnsToInclude.forEach(col => {
//             const originalKey = Object.keys(columnMapping).find(key => columnMapping[key] === col);
//             newItem[col] = item[originalKey];
//         });
//         return newItem;
//     });

//     // Create worksheet and workbook
//     const ws = XLSX.utils.json_to_sheet(transformedData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

//     // Convert workbook to binary array and save
//     const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
//     const blob = new Blob([wbout], { type: 'application/octet-stream' });
//     saveAs(blob, 'SmartCube(SC) Reports and KPIs.xlsx');
// };
 


// const downloadExcel = () => {
//   // Define the columns to keep and the desired order
//   const columnsToInclude = [
//     "SMARTCUBE SECTOR",
//     "PEPSICO L0 CATEGORY",
//     "PEPSICO L1 CATEGORY",
//     "MAPPED SMARTCUBE CATEGORIES",
//     "MARKET SIZE 2025",
//     "MARKET SIZE 2026",
//     "MARKET SIZE 2027",
//     "MARKET SIZE 2028",
//     "UOM",
//     "MARKET SIZE CAGR",
//     "CATEGORY RISK"
//   ];

//   const columnMapping = {
//     smartCubeSector: "SMARTCUBE SECTOR",
//     l0Category: "PEPSICO L0 CATEGORY",
//     l1Category: "PEPSICO L1 CATEGORY",
//     smartCubeCategoryWithLink: "MAPPED SMARTCUBE CATEGORIES",
//     marketSize_0: "MARKET SIZE 2025",
//     marketSize_1: "MARKET SIZE 2026",
//     marketSize_2: "MARKET SIZE 2027",
//     marketSize_3: "MARKET SIZE 2028",
//     uom: "UOM",
//     cagr: "MARKET SIZE CAGR",
//     categoryRisk: "CATEGORY RISK"
//   };

//   // Transform the data
//   const transformedData = data.map(item => {
//     const newItem = {};
//     columnsToInclude.forEach(col => {
//       const originalKey = Object.keys(columnMapping).find(key => columnMapping[key] === col);
//       let value = item[originalKey];
  
//       // Format MAPPED SMARTCUBE CATEGORIES
//       if (col === "MAPPED SMARTCUBE CATEGORIES" && typeof value === 'string') {
//         const [label, url] = value.split('$$');
//         const sector = item["smartCubeSector"] || '';
//         // value = `${sector} - ${label}\r\nReport URL : ${url}`;
//         // value = `${sector} - ${label}.   Report URL : ${url}`;
//         value = `${sector} - ${label}.  \r\nReport URL : ${url}`;

//       }
  
//       newItem[col] = value;
//     });
//     return newItem;
//   });
  
//   const ws = XLSX.utils.json_to_sheet(transformedData);
  
//   // ✅ Apply wrapText to each row in the "MAPPED SMARTCUBE CATEGORIES" column
//   const mappedColIndex = columnsToInclude.indexOf("MAPPED SMARTCUBE CATEGORIES");
//   const columnLetter = XLSX.utils.encode_col(mappedColIndex);
//   const range = XLSX.utils.decode_range(ws['!ref']);
  
//   for (let R = range.s.r + 1; R <= range.e.r; ++R) {
//     const cellAddr = `${columnLetter}${R + 1}`;
//     if (ws[cellAddr]) {
//       if (!ws[cellAddr].s) ws[cellAddr].s = {};
//       ws[cellAddr].s.alignment = { wrapText: true };
//     }
//   }
  
  

//   // Create worksheet and workbook
//   // const ws = XLSX.utils.json_to_sheet(transformedData);
//   const wb = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

//   // Convert workbook to binary array and save
//   const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
//   const blob = new Blob([wbout], { type: 'application/octet-stream' });
//   saveAs(blob, 'SMARTCUBE(SC) REPORTS AND KPIS.xlsx');
// };


/* istanbul ignore next */
const downloadExcel = async () => {
  // Define the columns to keep and the desired order
  const columnsToInclude = [
    "SMARTCUBE SECTOR",
    "PEPSICO L0 CATEGORY",
    "PEPSICO L1 CATEGORY",
    "MAPPED SMARTCUBE CATEGORIES",
    "MARKET SIZE 2025",
    "MARKET SIZE 2026",
    "MARKET SIZE 2027",
    "MARKET SIZE 2028",
    "UNIT OF MEASURE",
    "MARKET SIZE CAGR",
    "CATEGORY RISK"
  ];

  const columnMapping = {
    smartCubeSector: "SMARTCUBE SECTOR",
    l0Category: "PEPSICO L0 CATEGORY",
    l1Category: "PEPSICO L1 CATEGORY",
    smartCubeCategoryWithLink: "MAPPED SMARTCUBE CATEGORIES",
    marketSize_0: "MARKET SIZE 2025",
    marketSize_1: "MARKET SIZE 2026",
    marketSize_2: "MARKET SIZE 2027",
    marketSize_3: "MARKET SIZE 2028",
    uom: "UNIT OF MEASURE",
    cagr: "MARKET SIZE CAGR",
    categoryRisk: "CATEGORY RISK"
  };

  // Transform the data
  const transformedData = data.map(item => {
    const newItem = {};
    columnsToInclude.forEach(col => {
      const originalKey = Object.keys(columnMapping).find(key => columnMapping[key] === col);
      let value = item[originalKey];

      // Format MAPPED SMARTCUBE CATEGORIES
      if (col === "MAPPED SMARTCUBE CATEGORIES" && typeof value === 'string') {
        const [label, url] = value.split('$$');
        const sector = item["smartCubeSector"] || '';
        value = `${sector} - ${label}.  \r\nReport URL : ${url}`;
      }

      newItem[col] = value;
    });
    return newItem;
  });

  await exportRowsToExcel({
    rows: transformedData,
    headers: columnsToInclude,
    fileName: 'SMARTCUBE(SC) REPORTS AND KPIS.xlsx',
    columnWidths: columnsToInclude.map(col => (col === "MAPPED SMARTCUBE CATEGORIES" ? 50 : 20)),
    // Wrap text in "MAPPED SMARTCUBE CATEGORIES" column
    decorate: sheet => {
      const mappedColNumber = columnsToInclude.indexOf("MAPPED SMARTCUBE CATEGORIES") + 1;
      if (!mappedColNumber) return;
      sheet.getColumn(mappedColNumber).eachCell((cell, rowNumber) => {
        if (rowNumber > 1) cell.alignment = { wrapText: true };
      });
    },
  });
};



  const smartCubeTableRef = useRef()

  const { showToast } = useToast();

  /* istanbul ignore next */
  const checkPDFDownloaded = (isPdfDownloaded, isModal, fileURL, isExcel, isTable, isJpeg) => {
    if(isPdfDownloaded){
        if(isModal){
            showToast('success', !isJpeg ? "PDF of full page successfully downloaded." : 'JPEG of full page successfully downloaded.', {
                icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
            });
        } else if(isTable){
            showToast('success', !isJpeg ? "PDF of a table successfully downloaded." : 'JPEG of a table successfully downloaded.', {
                icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
            });
        }
        else{
            showToast('success', !isJpeg ? "PDF of a chart successfully downloaded.": 'JPEG of a chart successfully downloaded.', {
                icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
            });
        }
    }
    else if(isExcel){
        downloadExcel()
    }
    else{
        showToast('Error', "Failed to download. Please try again.", {
            icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
        });
    }   
  }


  return (
    <>
    <div ref={smartCubeTableRef}>

      <span style={{float: 'right', position: 'relative', top: '1rem', zIndex: '9999', right: '0.25rem'}}>
            <DropdownWithIcons modalRef={smartCubeTableRef} kpiName={"SmartCube(SC) Reports and KPIs"} checkPDFDownloaded={checkPDFDownloaded} isTable={true}/>
      </span>
    {/* <button type="primary" title='Download Data' onClick={downloadExcel} className="download-excel">
							<img src={download_logo} alt="download_logo" style={{position: 'relative', top: '2px'}}/>
		</button> */}
    <DataTable
      columns={columns}
      data={data}
      // filters={filters}
      isDark={false}
      // enableSorting={false}
      isExpandable={false}
      pageIndex={0}
      pageSize={10}
      selection="single"
      size="large"
      tableDescription=""
      tableHeader="SmartCube(SC) Reports and KPIs"
      showColumnFilters={false}
    // toolbarActions= {[
    //   {
    //     text: 'Button',
    //     variant: 'secondary',
    //     onClick: () => alert('secondary button clicked'),
    //   },
    //   {
    //     text: 'Button',
    //     variant: 'primary',
    //     onClick: () => alert('primary button clicked'),
    //   },
    // ]}
    />
    </div>
    </>
  )
}


export default SmartCubeTable;